import { sendWsMessage } from '../../connection/create-ws-bridge.js';
import type WebSocket from 'ws';

export function sendDeploySessionToPreviewResult(
  ws: WebSocket | null,
  id: string,
  payload: {
    ok?: boolean;
    error?: string;
    deployBranch?: string;
    previewParentPath?: string;
  },
): void {
  if (!ws) return;
  sendWsMessage(ws, { type: 'deploy_session_to_preview_result', id, ...payload });
}
